import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Questionnaire } from '../../../../types';
import { putQuestionnaire } from '../../../../../../apis/questionnaires/requests';
import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { getQuestionnaireFormData } from '../utils';

export const useUpdateQuestionnaire = (onSuccess: () => void) => {
  const queryClient = useQueryClient();

  const { isSuccess, mutate: updateQuestionnaire, isLoading } = useMutation({
    mutationFn: (questionnaire: Questionnaire) => {
      const formData = getQuestionnaireFormData(questionnaire);

      return putQuestionnaire(String(questionnaire._id), formData);
    },
    onSuccess: (_, questionnaire) => {
      queryClient.invalidateQueries(['questionnaire', questionnaire._id]);
    }
  });

  const handleUpdateQuestionnaire = (questionnaire: Questionnaire) => {
    updateQuestionnaire(questionnaire);
  };

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Questionnaire saved!', { variant: 'success' });

      onSuccess();
    }
  }, [isSuccess, onSuccess]);

  return { updateQuestionnaire: handleUpdateQuestionnaire, isLoading };
};
